import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ModelSelectionService {
  // BehaviorSubject that always emits the latest selected model name
  private readonly selectedModelNameSubject = new BehaviorSubject<string>('ChatGPT 5.2');
  
  // Public Observable that multicasts the latest value to all subscribers
  readonly selectedModelName$: Observable<string> = this.selectedModelNameSubject.asObservable().pipe(
    shareReplay(1) // Multicast and replay the latest value to new subscribers
  );

  /**
   * Update the selected model name - emits to all subscribers
   */
  setSelectedModelName(modelName: string): void {
    this.selectedModelNameSubject.next(modelName || '');
  }

  /**
   * Get the current selected model name (synchronous)
   */
  getSelectedModelName(): string {
    return this.selectedModelNameSubject.value;
  }
}
